import { OrgTreeApi, OrgPageApi } from "@/api/organization/index";

export default {
  //树查询
  async getOrgTree({ commit, state }, params) {
    //强制刷新
    if (params && params.force) {
      state.treeLoading = true;
      let res = await OrgTreeApi();
      console.log(res);
      if (res.code == "0") {
        let data = res.data;
        commit("setTreeData", data);
      }
      state.treeLoading = false;
    } else {
      //如果有缓存了就不走接口
      if (state.treeData.length == 0) {
        state.treeLoading = true;
        let res = await OrgTreeApi();
        if (res.code == "0") {
          let data = res.data;
          commit("setTreeData", data);
        }
        state.treeLoading = false;
      }
    }
  },

  //列表查询
  async getOrgPage({ commit, state }, params) {
    state.tableLoading = true;
    let res = await OrgPageApi(params);
    if (res.code == "0") {
      var data = res.data.records;
      commit("setTableData", data);
      state.pageData.pageTotal = Number(res.data.total); //总条数
    }
    state.tableLoading = false;
  }
};
